import React from 'react';
import { Typography } from '@material-ui/core';
import {
  TITLE_ERROR,
  SUBTITLE_ERROR,
  WHATSAPP_LINE_CONTACT,
} from '../../../constants/texts';
import { useTicketErrorTextStyles } from './styles';

const TicketErrorText = () => {
  const classes = useTicketErrorTextStyles();
  return (
    <React.Fragment>
      <Typography className={classes.title}>{TITLE_ERROR}</Typography>
      <Typography className={classes.subtitle}>{SUBTITLE_ERROR}</Typography>
      <Typography className={classes.contactWhatsapp}>
        {WHATSAPP_LINE_CONTACT}
      </Typography>
    </React.Fragment>
  );
};

export default TicketErrorText;
